import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import AuthLayout from "@/components/auth/AuthLayout";
import api, { formatApiError } from "@/utils/api";

export default function VerifyEmailPage() {
  const [search] = useSearchParams();
  const token = search.get("token");
  const [state, setState] = useState({ status: "verifying", message: "" });

  useEffect(() => {
    if (!token) {
      setState({ status: "error", message: "Missing verification token." });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post(`/api/auth/verify-email?token=${encodeURIComponent(token)}`);
        setState({ status: "success", message: data.message || "Email verified." });
      } catch (e) {
        setState({ status: "error", message: formatApiError(e) });
      }
    })();
  }, [token]);

  return (
    <AuthLayout
      title={state.status === "success" ? "Email verified" : state.status === "error" ? "Verification failed" : "Verifying your email…"}
      subtitle={state.status === "verifying" ? "One moment please." : state.message}
      sideTitle="Thanks for confirming your email."
      sideBullets={[
        "Your account is now secured",
        "You'll receive important reports at this address",
        "You can now generate personalized growth and nutrition reports",
      ]}
    >
      <div className="flex flex-col items-start gap-6" data-testid="verify-email-result">
        {state.status === "verifying" && (
          <div className="w-8 h-8 border-2 border-sky-400 border-t-transparent rounded-full animate-spin" />
        )}
        {state.status === "success" && (
          <>
            <div className="text-emerald-300 text-5xl">✓</div>
            <Link
              to="/dashboard"
              data-testid="verify-email-go-dashboard"
              className="px-4 py-2.5 rounded-lg bg-gradient-to-r from-sky-500 to-indigo-500 text-white font-medium"
            >
              Go to dashboard
            </Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <div className="text-rose-300 text-5xl">✕</div>
            <Link
              to="/login"
              data-testid="verify-email-go-login"
              className="text-sky-400 hover:text-sky-300 text-sm"
            >
              Back to login
            </Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
